export default __webpack_public_path__ + "static/media/card-lock.c8b026f6.svg";